/**
 * WishlistCard Component
 * Displays a wishlist as a collection card (Paiseh A.dc design refresh)
 */

import { Wishlist } from '@/types'
import { Link } from 'react-router-dom'
import { getOccasionTheme } from '@/utils/occasionTheme'
import { analyticsEvents } from '@/utils/analytics'
import toast from 'react-hot-toast'

interface WishlistCardProps {
  wishlist: Wishlist
}

export const WishlistCard = ({ wishlist }: WishlistCardProps) => {
  const theme = getOccasionTheme(wishlist.occasion, wishlist.emoji)
  const isShared = wishlist.visibility === 'shared'

  const handleShare = (e: React.MouseEvent) => {
    e.preventDefault()
    const link = wishlist.shareLink || `https://paiseh.sg/w/${wishlist.id}`
    navigator.clipboard.writeText(link)
    analyticsEvents.wishlistShared(wishlist.id, 'copy_link')
    toast.success('Link copied to clipboard!')
  }

  return (
    <div className="bg-white rounded-[24px] border border-ink/[.06] shadow-[0_8px_24px_rgba(43,36,32,.05)] overflow-hidden flex flex-col">
      <Link to={`/wishlists/${wishlist.id}`} className="block">
        <div
          className="h-[120px] relative flex items-center justify-center"
          style={{ background: theme.cover }}
        >
          <span className="text-[44px] leading-none">{theme.emoji}</span>
          {isShared && (
            <span className="absolute top-3 right-3 bg-white/90 text-[#4E7241] text-[11.5px] font-bold px-[11px] py-[5px] rounded-full">
              ● Shared
            </span>
          )}
        </div>
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <div
          className="text-xs font-bold uppercase tracking-[0.05em]"
          style={{ color: theme.tag }}
        >
          {wishlist.occasion || 'Wishlist'}
        </div>
        <Link to={`/wishlists/${wishlist.id}`}>
          <h3 className="font-display font-bold text-[21px] mt-[5px] mb-3.5 text-ink hover:text-paiseh-orange transition-colors">
            {wishlist.title}
          </h3>
        </Link>
        <div className="flex items-center gap-4 text-[13.5px] text-[#8A7E72] font-semibold">
          <span>🎁 {wishlist.itemCount} items</span>
          {wishlist.reservedCount > 0 && (
            <span className="text-paiseh-olive">✓ {wishlist.reservedCount} reserved</span>
          )}
        </div>
        <div className="mt-4 flex gap-2.5 pt-0">
          <Link
            to={`/wishlists/${wishlist.id}`}
            className="flex-1 text-center bg-[#FCF2E7] text-paiseh-orangeDark font-bold text-[13.5px] py-2.5 rounded-full hover:bg-paiseh-peach transition-colors"
          >
            Open
          </Link>
          <button
            onClick={handleShare}
            className="text-center bg-white border border-ink/[.12] text-ink font-bold text-[13.5px] px-4 py-2.5 rounded-full hover:border-paiseh-orange transition-colors"
          >
            Share ↗
          </button>
        </div>
      </div>
    </div>
  )
}
